import axios from 'axios';
import { Pagination } from 'components/Pagination';
import {
  Animate,
  Grid,
  Search,
  Table,
  ViewContext,
} from 'components/lib';
import DateUtils from 'helpers/dateUtils';
import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styles from './styles.module.scss';
import { Providers } from 'helpers/constants';
import { getLatestSubmissionNumber } from 'helpers/submission';

export function QuotesC() {
  const { id: company_id } = useParams();
  const [payload, setPayload] = useState();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [searchQueryString, setSearchQueryString] = useState('');
  const navigate = useNavigate();

  const format = new DateUtils();
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  const context = useContext(ViewContext);

  async function listQuotes(page, search) {
    setLoading(true);

    await axios
      .get(
        `/api/quote?page=${page}&search=${search}&company_id=${company_id}`
      )
      .then(async (res) => {
        setPayload(res.data.data);

        var tempData = [];
        const timezone = await format.getTimezone();

        res.data.data.data.map((value) => {
          const submissionNumber = getLatestSubmissionNumber(value);

          const canEdit =
            value.policy_type !== 'personal_auto' && value.policy_type !== 'renters';
          tempData.push({
            id: value.id,
            submission_number: submissionNumber,
            'DOT Number': value.dot_number,
            company_id: value.company_id,
            policy_type: value.policy_type,
            can_edit: canEdit,
            effective_date: format.formatIsoToCommomDate(
              value.effective_date
            ),
            uploaded_by: value.uploaded_by,
            carrier: value.carrier,
            premium: value.premium
              ? formatter.format(value.premium)
              : formatter.format(0),
            Drivers: value.number_of_drivers,
            Vehicles: value.number_of_vehicles,
            Trailers: value.number_of_trailers,
            'Created At': format.timestamp(value.createdAt, timezone),
            status: value.status,
          });
        });

        setLoading(false);
        setData(tempData);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);

        context.notification.show(
          'Failed to load table data',
          'error',
          true,
          'toast',
          'x-circle'
        );
      });
  }

  useEffect(() => {
    listQuotes(page, searchQueryString);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQueryString]);

  useEffect(() => {
    listQuotes(page, '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Animate type="pop">
      <Grid cols="1">
        <div className={styles.wrapper}>
          <div style={{ margin: 20 }}>
            <div style={{ marginBottom: 30 }}>
              <Search
                callback={(query) => {
                  setSearchQueryString(query);
                }}
              />
            </div>
            <Table
              loading={loading}
              data={payload && payload.data ? data : null}
              hide={['id', 'company_id', 'policy_type', 'can_edit']}
              badge={{
                col: 'status',
                color: 'gray',
                condition: [
                  { value: 'created', color: 'gray' },
                  { value: 'submitted', color: 'blue' },
                  { value: 'declined', color: 'red' },
                  { value: 'requested bind', color: 'purple' },
                  { value: 'active', color: 'green' },
                ],
              }}
              actions={{
                custom: [
                  {
                    icon: 'eye',
                    tooltip: 'Review this quote',
                    action: (row) => {
                      const reviewUrl = '/app/quote/review';

                      navigate(reviewUrl, {
                        state: {
                          quote_id: row.id,
                          data: {
                            status: row.status,
                            submission_number: row.submission_number,
                            provider: Providers[row.carrier.replaceAll(' ', '')],
                          },
                        },
                      });
                    },
                  },
                  {
                    icon: 'edit',
                    tooltip: 'Edit this quote',
                    condition: { col: 'can_edit', value: true },
                    action: (row) => {
                      navigate('/app/quote/run', {
                        state: {
                          data: {
                            company_id: row.company_id,
                            quote_id: row.id,
                          },
                        },
                      });
                    },
                  },
                ],
              }}
            />
            {payload && (
              <Pagination
                pagesCount={payload.pages_count}
                active={payload.page}
                onChange={async (newPage) => {
                  setPage(newPage);
                  listQuotes(newPage, searchQueryString);
                }}
              />
            )}
          </div>
        </div>
      </Grid>
    </Animate>
  );
}
